import React from "react";
import KakaoLogin from "react-kakao-login";
import KakaoIcon from "./logo_svg/btn_kakao.svg";
import GoogleIcon from "./logo_svg/btn_google.svg";
import NaverIcon from "./logo_svg/btn_naver.svg";

import "./FxmsLogin.css";
export const OauthLink = () => {
  let naver_api = process.env.REACT_APP_NAVER_OAUTH_API_URL;
  let kakao_api = process.env.REACT_APP_KAKAO_OAUTH_API_URL;
  let google_api = process.env.REACT_APP_GOOGLE_OAUTH_API_URL;

  return (
    <div className="socialLogin">
      <ul className="loginBtnWrap kakao">
        <a href={kakao_api}>
          <li id="socialIcon">
            <img src={KakaoIcon} alt="kakao_image_error" />
          </li>
          <li id="socialName">카카오계정으로 로그인하기</li>
        </a>
      </ul>
      <ul className="loginBtnWrap naver">
        <a href={naver_api}>
          <li id="socialIcon">
            <img src={NaverIcon} alt="Naver_image_error" />
          </li>
          <li id="socialName">네이버계정으로 로그인하기</li>
        </a>
      </ul>
      <ul className="loginBtnWrap google">
        <a href={google_api}>
          <li id="socialIcon">
            <img src={GoogleIcon} alt="google_image_error" />
          </li>
          <li id="socialName">구글계정으로 로그인하기</li>
        </a>
      </ul>
    </div>
  );
};
